var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegrma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346625 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM11.93 5.48L10.62 11.67C10.52 12.11 10.26 12.21 9.89 12.01L7.89 10.53L6.89 11.46C6.84291 11.5215 6.7824 11.5715 6.71309 11.6062C6.64378 11.6408 6.56749 11.6592 6.49 11.66L6.63 9.66L10.33 6.31C10.5 6.17 10.33 6.09 10.09 6.23L5.55 9.08L3.55 8.46C3.12 8.33 3.11 8.03 3.64 7.83L11.35 4.83C11.73 4.72 12.05 4.94 11.93 5.48Z",
    fill: "#F4FBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegrma);
export default __webpack_public_path__ + "static/media/telegrma.4f477639232230ba9281548e44c32ee4.svg";
export { ForwardRef as ReactComponent };